export class FileType {
  public static readonly audio = 'audio';

  public static readonly video = 'video';

  public static readonly image = 'image';

  public static readonly text = 'text';
}
